<template>
  <a
    href="#"
    :disabled="isDisabled"
    :class="`btn btn-${variant} ${customClass}`"
    @click="executeEvent"
  >
    {{ isDisabled ? "Loading.." : content }}
  </a>
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    variant: {
      type: String,
      default: "primary"
    },
    content: {
      type: String,
      default: "Button"
    },
    customClass: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    executeEvent() {
      this.$emit("onClick");
    }
  }
};
</script>
